/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import requestService from "api/request";
import clsx from "clsx";
import { formatNumber } from "lib/helpers/format";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useAppSelector } from "store";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Autoplay } from "swiper/modules";
import useBreakpoint from "hooks/useBreakpoint";
const Home = () => {
  const navigate = useNavigate();
  const { user, appGlobal } = useAppSelector((state) => state.app) as any;
  const [sort, setSort] = useState<
    "volume_24h" | "quote.USD.percent_change_1h" | "date_added"
  >("volume_24h");

  const [recent, setRecent] = useState<any>();
  const breakpoint = useBreakpoint();
  const { t } = useTranslation();
  const [tokens, setTokens] = useState<{
    tokens: Array<any>;
    total: number;
  }>({
    tokens: [],
    total: 0,
  });

  const getTokens = async () => {
    try {
      const res = await requestService.get("/guest/tokens", {
        params: {
          sort: sort,
          recent: recent,
        },
      });
      if (res && res.data) {
        setTokens(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTokens();
  }, [recent, sort]);

  const handleRedirectTrading = (token: any) => {
    navigate(`/trading?spot=${token?.symbol}`);
  };
  return (
    <div className="main-bitget global-theme black">
      <div />

      <div className="main-box lay-box clearfix">
        <div>
          <div
            data-fetch-key="data-v-374ca9d2:0"
            className="portal-wrapper"
            data-v-374ca9d2=""
          >
            <div className="home" data-v-374ca9d2="">
              <div id="homeBanner" className="home-box " data-v-374ca9d2="">
                {/**/}
                <div className="phone:hidden">
                  <div
                    className="defaultWeb  relative box-border flex overflow-hidden w-1/1 pad:h-auto phone:h-auto  pad:h-auto black"
                    data-v-2b9d2646=""
                  >
                    <div
                      className="max-w-[1200px] grid grid-cols-2 mx-auto px-5 py-5"
                      data-v-2b9d2646=""
                    >
                      <div
                        className=" z-1  flex flex-col justify-between mt-100px box-border <xl:mt-108px !pad:mt-0 pad:w-full pad:h-auto pad:pb-80px !phone:mt-0 phone:w-full phone:h-auto"
                        data-v-2b9d2646=""
                      >
                        <div
                          className="phone:flex phone:justify-between phone:items-center phone:gap-8px"
                          data-v-2b9d2646=""
                        >
                          <div
                            data-v-2b9d2646=""
                            className="flex flex-col py-18px"
                          >
                            <h1
                              data-v-2b9d2646=""
                              className="m-0 line-clamp-2 flex flex-wrap text-56px font-700 leading-[120%] text-v3PrimaryText pad:text-48px pad:font-700 phone:line-clamp-1 phone:max-w-190px phone:font-700 phone:text-16px phone:leading-22px"
                            >
                              {t("Sàn giao dịch Crypto thế hệ mới")}
                            </h1>
                            <div
                              data-v-2b9d2646=""
                              className="line-clamp-2 mt-12px text-20px leading-[140%] text-v3PrimaryText pad:text-14px pad:max-w-full pad:truncate phone:line-clamp-1 phone:text-12px phone:mt-4px phone:max-w-190px phone:leading-14px"
                            >
                              {t(`Mọi thứ đơn giản hơn với Sising.`)}
                            </div>
                          </div>
                          {/* <img
                            width={343}
                            height={343}
                            src="/home_files/home_banner_white.png"
                            alt="bitget_home_banner_default_h5"
                            className="pro:hidden air:hidden pad:mt-24px pad:w-500px pad:h-500px phone:w-132px phone:h-132px"
                            data-v-2b9d2646=""
                          /> */}
                        </div>
                      </div>
                      <div className="flex items-center justify-center">
                        <img
                          src="https://assets.staticimg.com/brisk-web/1.0.17/media/9fae79f134b5614fcbc0.png"
                          alt=""
                          className=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/**/}
                <div className="minPhone:hidden">
                  <div
                    className="defaultWeb  relative box-border flex overflow-hidden w-1/1 pad:h-auto h-auto black"
                    data-v-2b9d2646=""
                  >
                    <div
                      className="relative justify-between flex w-1200px mx-auto box-border <xl:w-full <xl:px-24px pad:flex-col pad:items-center pad:px-24px phone:items-center phone:px-16px"
                      data-v-2b9d2646=""
                    >
                      <div
                        className="w-600px z-1 h-600px flex flex-col justify-between mt-100px box-border <xl:mt-108px !pad:mt-0 pad:w-full pad:h-auto pad:pb-80px !phone:mt-0 phone:w-full phone:h-auto"
                        data-v-2b9d2646=""
                      >
                        <div
                          className="phone:flex phone:justify-between phone:items-center phone:gap-8px"
                          data-v-2b9d2646=""
                        >
                          <div
                            data-v-2b9d2646=""
                            className="flex flex-col py-18px"
                          >
                            <h1
                              data-v-2b9d2646=""
                              className="text-[35px] font-[700] text-[#fff] text-center mb-3"
                            >
                              {t("Sàn giao dịch Crypto thế hệ mới")}
                            </h1>
                            <div
                              data-v-2b9d2646=""
                              className="text-[16px] text-[#ccc] text-center"
                            >
                              {t(`Mọi thứ đơn giản hơn với Sising.`)}
                            </div>
                          </div>
                          {/* <img
                            width={343}
                            height={343}
                            src="/home_files/home_banner_white.png"
                            alt="bitget_home_banner_default_h5"
                            className="pro:hidden air:hidden pad:mt-24px pad:w-500px pad:h-500px phone:w-132px phone:h-132px"
                            data-v-2b9d2646=""
                          /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div
                className="h5-kong-zone  my-[32px]  md:my-[50px] md:px-[50px] max-w-[1036px] mx-auto"
                data-v-374ca9d2=""
              >
                <div className="flex justify-between gap-[10px]">
                  <div className="container-item flex flex-col items-center flex-1 break-word mb-4">
                    <a
                      href="/"
                      target="_blank"
                      className="border border-solid border-v3StrengthBorder0 rounded-[50%] w-46px h-46px flex items-center justify-center text-v3PrimaryText"
                    >
                      <img
                        src="/img/kucoin-seeklogo.png"
                        className="w-[46px] rounded-full"
                        alt=""
                      />
                    </a>
                    <span className="mt-10px text-12px text-v3PrimaryText text-center px-3px">
                      {t("Sising Market")}
                    </span>
                  </div>
                  <div className="container-item flex flex-col items-center flex-1 break-word mb-4">
                    <a
                      href="#"
                      target="_blank"
                      className="border border-solid border-v3StrengthBorder0 rounded-[50%] w-46px h-46px flex items-center justify-center text-v3PrimaryText"
                    >
                      <img
                        src="/img/menu2.jpg"
                        className="w-[46px] rounded-full"
                        alt=""
                      />
                    </a>
                    <span className="mt-10px text-12px text-v3PrimaryText text-center px-3px">
                      {t("Trung tâm Sising Group")}
                    </span>
                  </div>
                  <div className="container-item flex flex-col items-center flex-1 break-word mb-4">
                    <a
                      href="#"
                      target="_blank"
                      className="border border-solid border-v3StrengthBorder0 rounded-[50%] w-46px h-46px flex items-center justify-center text-v3PrimaryText"
                    >
                      <img
                        src="/img/menu7.jpg"
                        className="w-[46px] rounded-full"
                        alt=""
                      />
                    </a>
                    <span className="mt-10px text-12px text-v3PrimaryText text-center px-3px">
                      {t("DEX - Sising Swap")}
                    </span>
                  </div>
                  <div className="container-item flex flex-col items-center flex-1 break-word mb-4">
                    <a
                      href="#"
                      target="_blank"
                      className="border border-solid border-v3StrengthBorder0 rounded-[50%] w-46px h-46px flex items-center justify-center text-v3PrimaryText"
                    >
                      <img
                        src="/img/menu6.jpg"
                        className="w-[46px] rounded-full"
                        alt=""
                      />
                    </a>
                    <span className="mt-10px text-12px text-v3PrimaryText text-center px-3px">
                      {t("BMC Gloombay Invest")}
                    </span>
                  </div>
                </div>
                <div className="mt-12px flex justify-between">
                  <div className="container-item flex flex-col items-center flex-1 break-word mb-4">
                    <a
                      href="#"
                      target="_blank"
                      className="border border-solid border-v3StrengthBorder0 rounded-[50%] w-46px h-46px flex items-center justify-center text-v3PrimaryText"
                    >
                      <img
                        src="/img/menu5.jpg"
                        className="w-[46px] rounded-full"
                        alt=""
                      />
                    </a>
                    <span className="mt-10px text-12px text-v3PrimaryText text-center px-3px">
                      Swap
                    </span>
                  </div>
                  <div className="container-item flex flex-col items-center flex-1 break-word mb-4">
                    <a
                      href="#"
                      target="_blank"
                      className="border border-solid border-v3StrengthBorder0 rounded-[50%] w-46px h-46px flex items-center justify-center text-v3PrimaryText"
                    >
                      <img
                        src="/img/menu3.jpg"
                        className="w-[46px] rounded-full"
                        alt=""
                      />
                    </a>
                    <span className="mt-10px text-12px text-v3PrimaryText text-center px-3px">
                      {t("Lộ trình GOM Coin")}
                    </span>
                  </div>
                  <div className="container-item flex flex-col items-center flex-1 break-word mb-4">
                    <a
                      href="#"
                      target="_blank"
                      className="border border-solid border-v3StrengthBorder0 rounded-[50%] w-46px h-46px flex items-center justify-center text-v3PrimaryText"
                    >
                      <img
                        src="/img/menu1.jpg"
                        className="w-[46px] rounded-full"
                        alt=""
                      />
                    </a>
                    <span className="mt-10px text-12px text-v3PrimaryText text-center px-3px">
                      {t("Phần thưởng giới thiệu")}
                    </span>
                  </div>
                  <div className="container-item flex flex-col items-center flex-1 break-word mb-4">
                    <a
                      href="#"
                      target="_blank"
                      className="border border-solid border-v3StrengthBorder0 rounded-[50%] w-46px h-46px flex items-center justify-center text-v3PrimaryText"
                    >
                      <img
                        src="/img/menu8.jpg"
                        className="w-[46px] rounded-full"
                        alt=""
                      />
                    </a>
                    <span className="mt-10px text-12px text-v3PrimaryText text-center px-3px">
                      {t("Hệ sinh thái Sising")}
                    </span>
                  </div>
                </div>
              </div> */}
              <div
                data-fetch-key={0}
                className="trad max-w-[calc(100%-48px)] w-1200px !mx-auto <xl:mx-24px <lg-new:w-895px phone:mx-16px phone:mt-32px phone:w-full phone:max-w-[calc(100%-32px)]"
                data-v-374ca9d2=""
              >
                <Swiper
                  slidesPerView={breakpoint === "mobile" ? 2 : 3}
                  loop
                  spaceBetween={10}
                  autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                  }}
                  pagination={true}
                  modules={[Pagination, Autoplay]}
                  centeredSlides
                  className="mySwiper"
                >
                  <SwiperSlide>
                    <img
                      src="https://sgp1.digitaloceanspaces.com/static.nami/nami.exchange/images/screen/homepage/banner_graphics_fit.webp"
                      alt=""
                      className="h-full md:h-[200px] w-[400px] md:w-full"
                    />
                  </SwiperSlide>

                  <SwiperSlide>
                    <img
                      src="https://files.amberblocks.com/media/chnbzaa92ook5tnj/posts/phc6eron4qjfof22/fsmrj9mwrcefmvdbt9yluwglkhdvax6d/solana-ethereum-revenue.jpeg"
                      alt=""
                      className="h-full md:h-[200px] w-[400px] md:w-full"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="https://files.amberblocks.com/thumbnail/chnbzaa92ook5tnj/posts/pbglbp826kjlkduf/f38aoxap3lve4so9rhly9bbrbzm2pr2n/meme-coin-sundog.jpg"
                      alt=""
                      className="h-full md:h-[200px] w-[400px] md:w-full"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="https://files.amberblocks.com/thumbnail/chnbzaa92ook5tnj/posts/pwn2fr28y4l8630o/f3yv9l4r9415kn0iwl25jgnr5b8bujfi/solana-etf.jpg"
                      alt=""
                      className="h-full md:h-[200px] w-[400px] md:w-full"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="https://files.amberblocks.com/thumbnail/chnbzaa92ook5tnj/posts/pq2x8z68bpxzvspm/f03lzo1az0md9k9jkk9haxljsoqpbz8p/su-that-memecoin.jpg"
                      alt=""
                      className="h-full md:h-[200px] w-[400px] md:w-full"
                    />
                  </SwiperSlide>
                </Swiper>
              </div>
              <div
                data-v-69941316=""
                className="minPhone:hidden"
                style={{ padding: 15 }}
              >
                <div className="micro micro-dark">
                  <div className="flex gap-16px flex-col lg:flex-row mb-32px phone:mb-16px">
                    <div className="lg:w-[calc(50%-8px)]">
                      <div
                        data-v-573dee0d=""
                        className="w-auto overflow-hidden flex flex-1 flex-col gap-15px md:gap-23px coin-card border-1px border-solid border-borderStrengthOne px-16px py-15px md:p-24px cursor-pointer !pb-15px bg-bg rounded-8px"
                      >
                        <div
                          data-v-573dee0d=""
                          className="flex flex-1 overflow-hidden items-start gap-12px md:!gap-20px lg:!gap-12px 2xl:!gap-20px"
                        >
                          <img
                            data-v-573dee0d=""
                            className="w-[25px] h-25px rounded-full md:w-48px md:h-48px"
                            src={appGlobal?.LOGO_APP?.value}
                            alt="coin"
                          />
                          <div
                            data-v-573dee0d=""
                            className="flex flex-1 flex-col gap-12px md:gap-16px overflow-hidden"
                          >
                            <div className="min-h-38px">
                              <div className="flex gap-24px md:!gap-64px lg:!gap-48px 2xl:!gap-64px">
                                <div className="flex flex-col gap-y-4px">
                                  <div className="text-ellipsis overflow-hidden text-[20px] leading-20px text-dsColorTextPrimary font-600">
                                    GOM/USDT
                                  </div>
                                  <div className="text-ellipsis overflow-hidden text-12px leading-120% text-dsColorTextTertiary">
                                    Sising
                                  </div>
                                </div>
                                <div className="flex flex-col gap-y-4px">
                                  <div className="text-ellipsis overflow-hidden text-14px leading-20px text-dsColorTextPrimary font-600">
                                    {appGlobal?.PRICE_GOM?.value}$
                                  </div>
                                  <div className="text-ellipsis overflow-hidden text-12px leading-120% text-dsColorTextTertiary">
                                    {t("Giá gần nhất")}
                                  </div>
                                </div>
                                <div className="flex flex-col gap-y-4px">
                                  <div className="text-14px leading-20px text-contentInverseTertiary font-600">
                                    --
                                  </div>
                                  <div className="text-ellipsis overflow-hidden text-12px leading-120% text-dsColorTextTertiary">
                                    {t("Tăng 24 giờ")}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-v-573dee0d=""
                              className="gap-8px flex flex-nowrap overflow-hidden lg:h-22px"
                            >
                              <div className="items-center justify-center py-4px px-8px gap-2px rounded-4px text-ellipsis whitespace-nowrap bg-bgSecondary text-10px leading-14px text-contentTertiary">
                                Inno
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          data-v-573dee0d=""
                          className="pt-16px border-t-1px border-line border-[#DEDFE0]"
                        >
                          <a href="#" target="_blank">
                            <div
                              data-v-f24d17e3=""
                              data-v-573dee0d=""
                              className="flex items-center flex-nowrap cursor-pointer"
                            >
                              <svg
                                data-v-f24d17e3=""
                                width={16}
                                height={16}
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-16px h-16px text-primaryText"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M8.00002 1.5C5.2386 1.5 3.00002 3.73858 3.00002 6.5V10.5H2V11.8333H14V10.5H13V6.5C13 3.73858 10.7614 1.5 8.00002 1.5Z"
                                  fill="var(--color-primary-text)"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M6 12.5C6 13.6046 6.89543 14.5 8 14.5C9.10457 14.5 10 13.6046 10 12.5H6Z"
                                  fill="#8E8E92"
                                />
                              </svg>

                              <div
                                data-v-f24d17e3=""
                                className="h-16px text-ellipsis overflow-hidden whitespace-nowrap mx-4px flex-1 text-12px leading-16px text-dsColorTextPrimary"
                              >
                                {t(
                                  "Cơn sốt lễ hội BWB: Vô vàn phần thưởng đang đợi bạn"
                                )}
                              </div>
                              <i
                                data-v-f24d17e3=""
                                className="mi-icon cursor-pointer color-contentTertiary"
                                style={{ fontSize: 12 }}
                              >
                                <svg
                                  data-v-f24d17e3=""
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path d="M17.03 12.53l-7.5 7.5a.75.75 0 11-1.06-1.06L15.44 12 8.47 5.03a.75.75 0 111.06-1.06l7.5 7.5a.75.75 0 010 1.06z" />
                                </svg>
                              </i>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-69941316="" className="swiper-container">
                  <div data-v-69941316="" className="swiper-container-con-card">
                    <div
                      data-v-69941316=""
                      className="swiper-container-con-card-scroll"
                    >
                      <div
                        data-v-69941316=""
                        className="swiper-container-con-card-scroll-list mt-12px flex justify-start gap-8px"
                      >
                        <div
                          data-v-69941316=""
                          className={clsx(
                            "cursor-pointer px-16px py-8px border border-1px border-solid border-v3StrengthBorder0 rounded-38px font-400 text-14px leading-16px text-v3PrimaryText ",
                            {
                              "bg-v3levelsurface1": sort === "volume_24h",
                            }
                          )}
                          onClick={() => setSort("volume_24h")}
                        >
                          {t("Khối lượng")}
                        </div>
                        <div
                          data-v-69941316=""
                          className={clsx(
                            "cursor-pointer px-16px py-8px border border-1px border-solid border-v3StrengthBorder0 rounded-38px font-400 text-14px leading-16px text-v3PrimaryText ",
                            {
                              "bg-v3levelsurface1":
                                sort === "quote.USD.percent_change_1h",
                            }
                          )}
                          onClick={() => setSort("quote.USD.percent_change_1h")}
                        >
                          {t("Tăng")}
                        </div>
                        <div
                          data-v-69941316=""
                          className={clsx(
                            "cursor-pointer px-16px py-8px border border-1px border-solid border-v3StrengthBorder0 rounded-38px font-400 text-14px leading-16px text-v3PrimaryText ",
                            {
                              "bg-v3levelsurface1": sort === "date_added",
                            }
                          )}
                          onClick={() => setSort("date_added")}
                        >
                          {t("Mới niêm yết")}
                        </div>
                      </div>
                    </div>

                    <div data-v-69941316="">
                      <div
                        data-v-5e1165f3=""
                        data-v-69941316=""
                        className="real-time-card-h5 mt-8px swiper-slide"
                      >
                        <div
                          data-v-5e1165f3=""
                          className="real-time-card-header h-20px flex justify-between items-center"
                        >
                          <div
                            data-v-5e1165f3=""
                            className="title text-v3TertiaryText font-400 text-12px leading-[140%] w-[35%] text-left"
                          >
                            <p data-v-5e1165f3="">{t("Cặp giao dịch")}</p>
                          </div>
                          <div
                            data-v-5e1165f3=""
                            className="title text-v3TertiaryText font-400 text-12px leading-[140%] w-[35%] text-right"
                          >
                            <p data-v-5e1165f3="">{t("Giá gần nhất")}</p>
                          </div>
                          <div
                            data-v-5e1165f3=""
                            className="title text-v3TertiaryText font-400 text-12px leading-[140%] w-[30%] text-right"
                          >
                            <p data-v-5e1165f3="">{t("Thay đổi")}</p>
                          </div>
                        </div>
                        <div data-v-5e1165f3="" className="min-h-[440px]">
                          {tokens?.total > 0 &&
                            tokens.tokens.map((token) => (
                              <div
                                data-v-5e1165f3=""
                                className="py-20px flex justify-between items-center"
                                onClick={() => handleRedirectTrading(token)}
                              >
                                <div
                                  data-v-5e1165f3=""
                                  className="flex items-center w-[35%]"
                                >
                                  <img
                                    data-v-5e1165f3=""
                                    alt="getCoinIconBySymbol-4-BTC"
                                    loading="lazy"
                                    src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${token.id}.png`}
                                    className="w-24px h-24px rounded-24px"
                                  />
                                  <div
                                    data-v-5e1165f3=""
                                    className="icon-name ml-8px font-500 text-16px text-v3PrimaryText leading-20px"
                                  >
                                    {token.symbol}/USDT
                                  </div>
                                </div>
                                <div
                                  data-v-5e1165f3=""
                                  className="price-text w-[35%] text-right font-500 text-16px text-v3PrimaryText leading-20px"
                                >
                                  {token?.quote?.USD?.price?.toFixed(2)}
                                </div>
                                <div
                                  data-v-5e1165f3=""
                                  className="w-[30%] flex justify-end"
                                >
                                  {/* ------bg-v3TradeBuyText---- */}
                                  <div
                                    data-v-5e1165f3=""
                                    className={clsx(
                                      "w-72px py-6px rounded-4px ",
                                      {
                                        "bg-v3TradeBuyText":
                                          token?.quote?.USD
                                            ?.percent_change_1h >= 0,
                                        "bg-v3TradeSellText":
                                          token?.quote?.USD?.percent_change_1h <
                                          0,
                                      }
                                    )}
                                  >
                                    <span
                                      data-v-5e1165f3=""
                                      dir="ltr"
                                      className="flex justify-center text-whiteText font-500 leading-[140%] floatNum text-14px "
                                    >
                                      {/**/}
                                      {token?.quote?.USD?.percent_change_1h?.toFixed(
                                        2
                                      )}
                                      %
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/**/}
              <div className="phone:hidden home-trend" data-v-374ca9d2="">
                <div
                  className="v2-home-markets mx-auto max-w-1200px box-border mt-70px <xl:w-full <xl:max-w-none <xl:px-24px <xl:mt-90px pad:mt-80px phone:mt-58px phone:px-16px"
                  data-v-374ca9d2=""
                >
                  <div>
                    <h1 className="market-title text-primaryText leading-58px text-48px font-600 mb-32px atIpad:text-40px atIpad:leading-48px phone:mb-16px phone:text-32px phone:leading-40px">
                      {t("Tiền điện tử phổ biến")}
                    </h1>
                  </div>
                  <div>
                    <div className="micro micro-dark">
                      <div className="flex gap-16px flex-col lg:flex-row mb-32px phone:mb-16px">
                        <div className="lg:w-[calc(50%-8px)]">
                          <div
                            data-v-573dee0d=""
                            className="w-auto overflow-hidden flex flex-1 flex-col gap-15px md:gap-23px coin-card border-1px border-solid border-borderStrengthOne px-16px py-15px md:p-24px cursor-pointer !pb-15px bg-bg rounded-8px"
                          >
                            <div
                              data-v-573dee0d=""
                              className="flex flex-1 overflow-hidden items-start gap-12px md:!gap-20px lg:!gap-12px 2xl:!gap-20px"
                            >
                              <img
                                data-v-573dee0d=""
                                className="w-40px h-40px rounded-full md:w-48px md:h-48px"
                                src={appGlobal?.LOGO_APP?.value}
                                alt="coin"
                              />
                              <div
                                data-v-573dee0d=""
                                className="flex flex-1 flex-col gap-12px md:gap-16px overflow-hidden"
                              >
                                <div className="min-h-38px">
                                  <div className="flex gap-24px md:!gap-64px lg:!gap-48px 2xl:!gap-64px">
                                    <div className="flex flex-col gap-y-4px">
                                      <div className="text-ellipsis overflow-hidden text-14px leading-20px text-dsColorTextPrimary font-600">
                                        GOM
                                      </div>
                                      <div className="text-ellipsis overflow-hidden text-12px leading-120% text-dsColorTextTertiary">
                                        Sising
                                      </div>
                                    </div>
                                    <div className="flex flex-col gap-y-4px">
                                      <div className="text-ellipsis overflow-hidden text-14px leading-20px text-dsColorTextPrimary font-600">
                                        {appGlobal?.PRICE_GOM?.value}$
                                      </div>
                                      <div className="text-ellipsis overflow-hidden text-12px leading-120% text-dsColorTextTertiary">
                                        {t("Giá gần nhất")}
                                      </div>
                                    </div>
                                    <div className="flex flex-col gap-y-4px">
                                      <div className="text-14px leading-20px text-contentInverseTertiary font-600">
                                        --
                                      </div>
                                      <div className="text-ellipsis overflow-hidden text-12px leading-120% text-dsColorTextTertiary">
                                        {t("Tăng 24 giờ")}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-v-573dee0d=""
                                  className="gap-8px flex flex-nowrap overflow-hidden lg:h-22px"
                                >
                                  <div className="items-center justify-center py-4px px-8px gap-2px rounded-4px text-ellipsis whitespace-nowrap bg-bgSecondary text-10px leading-14px text-contentTertiary">
                                    Inno
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-v-573dee0d=""
                              className="pt-16px border-t-1px border-line border-[#DEDFE0]"
                            >
                              <div
                                data-v-f24d17e3=""
                                data-v-573dee0d=""
                                className="flex items-center flex-nowrap cursor-pointer"
                              >
                                <svg
                                  data-v-f24d17e3=""
                                  width={16}
                                  height={16}
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-16px h-16px text-primaryText"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M8.00002 1.5C5.2386 1.5 3.00002 3.73858 3.00002 6.5V10.5H2V11.8333H14V10.5H13V6.5C13 3.73858 10.7614 1.5 8.00002 1.5Z"
                                    fill="var(--color-primary-text)"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M6 12.5C6 13.6046 6.89543 14.5 8 14.5C9.10457 14.5 10 13.6046 10 12.5H6Z"
                                    fill="#8E8E92"
                                  />
                                </svg>
                                <div
                                  data-v-f24d17e3=""
                                  className="h-16px text-ellipsis overflow-hidden whitespace-nowrap mx-4px flex-1 text-12px leading-16px text-dsColorTextPrimary"
                                >
                                  {t(
                                    "Cơn sốt lễ hội BWB: Vô vàn phần thưởng đang đợi bạn"
                                  )}
                                </div>
                                <i
                                  data-v-f24d17e3=""
                                  className="mi-icon cursor-pointer color-contentTertiary"
                                  style={{ fontSize: 12 }}
                                >
                                  <svg
                                    data-v-f24d17e3=""
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    aria-hidden="true"
                                  >
                                    <path d="M17.03 12.53l-7.5 7.5a.75.75 0 11-1.06-1.06L15.44 12 8.47 5.03a.75.75 0 111.06-1.06l7.5 7.5a.75.75 0 010 1.06z" />
                                  </svg>
                                </i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ top: 64 }} className="">
                    <div
                      className="market-v2-tab pb-16px bg-v3levelsurface0 pt-8px phone:pb-16px"
                      data-v-293c14d4=""
                    >
                      <div
                        data-v-69941316=""
                        className="swiper-container-con-card-scroll"
                      >
                        <div
                          data-v-69941316=""
                          className="swiper-container-con-card-scroll-list mt-12px flex justify-start gap-8px"
                        >
                          <div
                            data-v-69941316=""
                            className={clsx(
                              "cursor-pointer px-16px py-8px border border-1px border-solid border-v3StrengthBorder0 rounded-38px font-400 text-14px leading-16px text-v3PrimaryText ",
                              {
                                "bg-v3levelsurface1": sort === "volume_24h",
                              }
                            )}
                            onClick={() => setSort("volume_24h")}
                          >
                            {t("Khối lượng")}
                          </div>
                          <div
                            data-v-69941316=""
                            className={clsx(
                              "cursor-pointer px-16px py-8px border border-1px border-solid border-v3StrengthBorder0 rounded-38px font-400 text-14px leading-16px text-v3PrimaryText ",
                              {
                                "bg-v3levelsurface1":
                                  sort === "quote.USD.percent_change_1h",
                              }
                            )}
                            onClick={() =>
                              setSort("quote.USD.percent_change_1h")
                            }
                          >
                            {t("Tăng")}
                          </div>
                          <div
                            data-v-69941316=""
                            className={clsx(
                              "cursor-pointer px-16px py-8px border border-1px border-solid border-v3StrengthBorder0 rounded-38px font-400 text-14px leading-16px text-v3PrimaryText ",
                              {
                                "bg-v3levelsurface1": sort === "date_added",
                              }
                            )}
                            onClick={() => setSort("date_added")}
                          >
                            {t("Mới niêm yết")}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/**/}
                  </div>
                  <div
                    className="v3-marketSetTime flex flex-row justify-between"
                    style={{ display: "none" }}
                    data-v-ddec2522=""
                  />
                  <div
                    style={{ minHeight: 194 }}
                    className="max-w-[789px] w-full"
                  >
                    <div data-v-69941316="">
                      <div
                        data-v-5e1165f3=""
                        data-v-69941316=""
                        className="real-time-card-h5 mt-8px swiper-slide"
                      >
                        <div
                          data-v-5e1165f3=""
                          className="real-time-card-header h-20px flex justify-between items-center"
                        >
                          <div
                            data-v-5e1165f3=""
                            className="title text-v3TertiaryText font-400 text-12px leading-[140%] w-[35%] text-left"
                          >
                            <p data-v-5e1165f3="">{t("Cặp giao dịch")}</p>
                          </div>
                          <div
                            data-v-5e1165f3=""
                            className="title text-v3TertiaryText font-400 text-12px leading-[140%] w-[35%] text-right"
                          >
                            <p data-v-5e1165f3="">{t("Giá gần nhất")}</p>
                          </div>
                          <div
                            data-v-5e1165f3=""
                            className="title text-v3TertiaryText font-400 text-12px leading-[140%] w-[30%] text-right"
                          >
                            <p data-v-5e1165f3="">{t("Thay đổi")}</p>
                          </div>
                          <div
                            data-v-5e1165f3=""
                            className="title text-v3TertiaryText font-400 text-12px leading-[140%] w-[30%] text-right"
                          >
                            <p data-v-5e1165f3="">{t("Khối lượng 24H")}</p>
                          </div>
                          <div
                            data-v-5e1165f3=""
                            className="title text-v3TertiaryText font-400 text-12px leading-[140%] w-[30%] text-right"
                          >
                            <p data-v-5e1165f3="">{t("Hoạt động")}</p>
                          </div>
                        </div>
                        <div data-v-5e1165f3="" className="min-h-[440px]">
                          {tokens?.total > 0 &&
                            tokens.tokens.map((token) => (
                              <div
                                data-v-5e1165f3=""
                                className="py-20px flex justify-between items-center"
                                onClick={() => handleRedirectTrading(token)}
                              >
                                <div
                                  data-v-5e1165f3=""
                                  className="flex items-center w-[35%]"
                                >
                                  <img
                                    data-v-5e1165f3=""
                                    alt="getCoinIconBySymbol-4-BTC"
                                    loading="lazy"
                                    src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${token.id}.png`}
                                    className="w-24px h-24px rounded-24px"
                                  />
                                  <div
                                    data-v-5e1165f3=""
                                    className="icon-name ml-8px font-500 text-16px text-v3PrimaryText leading-20px"
                                  >
                                    {token.symbol}/USDT
                                  </div>
                                </div>
                                <div
                                  data-v-5e1165f3=""
                                  className="price-text w-[35%] text-right font-500 text-16px text-v3PrimaryText leading-20px"
                                >
                                  {formatNumber(
                                    token?.quote?.USD?.price?.toFixed(2)
                                  )}
                                </div>
                                <div
                                  data-v-5e1165f3=""
                                  className="w-[30%] flex justify-end"
                                >
                                  {/* ------bg-v3TradeBuyText---- */}
                                  <div
                                    data-v-5e1165f3=""
                                    className={clsx(
                                      "w-72px py-6px rounded-4px ",
                                      {
                                        "bg-v3TradeBuyText":
                                          token?.quote?.USD
                                            ?.percent_change_1h >= 0,
                                        "bg-v3TradeSellText":
                                          token?.quote?.USD?.percent_change_1h <
                                          0,
                                      }
                                    )}
                                  >
                                    <span
                                      data-v-5e1165f3=""
                                      dir="ltr"
                                      className="flex justify-center text-whiteText font-500 leading-[140%] floatNum text-14px "
                                    >
                                      {/**/}
                                      {token?.quote?.USD?.percent_change_1h?.toFixed(
                                        2
                                      )}
                                      %
                                    </span>
                                  </div>
                                </div>
                                <div
                                  data-v-5e1165f3=""
                                  className="price-text w-[35%] text-right font-500 text-16px text-v3PrimaryText leading-20px"
                                >
                                  {formatNumber(
                                    token?.quote?.USD?.volume_24h?.toFixed(2)
                                  )}
                                </div>
                                <div
                                  data-v-5e1165f3=""
                                  className="price-text w-[35%] text-right font-500 text-16px text-v3PrimaryText leading-20px"
                                >
                                  <Link
                                    to={`/trading?spot=${token?.symbol}`}
                                    className="text-primaryHoverBg font-[700]"
                                  >
                                    {t("Giao dịch")}
                                  </Link>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                      <div
                        data-v-4c26fe8c=""
                        className="flex justify-center mt-48px"
                      >
                        <Link
                          data-v-4c26fe8c=""
                          to="/market"
                          className="bit-link bit-link--default"
                        >
                          {/**/}
                          <span className="bit-link--inner">
                            <button
                              data-v-4c26fe8c=""
                              type="button"
                              className="bit-button bit-button--default bit-button--medium is-round"
                            >
                              {/**/}
                              {/**/}
                              {/**/}
                              <span>
                                <span data-v-4c26fe8c="">
                                  {t("Xem tất cả")}
                                </span>{" "}
                                <i
                                  data-v-4c26fe8c=""
                                  className="bit-icon rtl-rotate"
                                  style={{ fontSize: 14 }}
                                >
                                  <svg
                                    data-v-4c26fe8c=""
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    aria-hidden="true"
                                  >
                                    <path d="M17.03 12.53l-7.5 7.5a.75.75 0 11-1.06-1.06L15.44 12 8.47 5.03a.75.75 0 111.06-1.06l7.5 7.5a.75.75 0 010 1.06z" />
                                  </svg>
                                </i>
                              </span>
                              {/**/}
                            </button>
                          </span>
                          {/**/}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                data-v-69941316=""
                className="flex justify-center  items-center cursor-pointer mt-40px text-16px font-500 leading-[140%] text-primary pad:mt-30px pad:text-14px phone:flex phone:justify-center phone:font-400 phone:mt-0px phone:py-6px phone:text-14px"
                onClick={() => navigate("/market")}
              >
                {t("Xem thêm")}
                <i data-v-69941316="" className="bit-icon ml-8px rtl-rotate">
                  <svg
                    data-v-69941316=""
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                    className="phone:hidden"
                  >
                    <path d="M20.78 12.53l-6.75 6.75a.75.75 0 01-1.06-1.06l5.47-5.47H3.75a.75.75 0 110-1.5h14.69l-5.47-5.47a.75.75 0 111.06-1.06l6.75 6.75a.747.747 0 010 1.06z" />
                  </svg>{" "}
                  <svg
                    data-v-69941316=""
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                    className="minPhone:hidden"
                  >
                    <path d="M17.03 12.53l-7.5 7.5a.75.75 0 11-1.06-1.06L15.44 12 8.47 5.03a.75.75 0 111.06-1.06l7.5 7.5a.75.75 0 010 1.06z" />
                  </svg>
                </i>
              </div>

              <div className="" style={{ minHeight: 0 }} data-v-374ca9d2="" />
              <div
                className="exchange mt-160px mb-196px mx-auto max-w-1200px box-border <xl:w-full <xl:max-w-none <xl:px-24px pad:mt-80px pad:mb-120px phone:w-auto phone:mt-32px phone:mb-0 phone:pl-16px phone:pr-0"
                data-v-7c20b99d=""
                data-v-374ca9d2=""
              >
                <div
                  className="mb-60px pad:mb-32px phone:mb-20px"
                  data-v-7c20b99d=""
                >
                  <div
                    className="text-32px font-700 leading-[120%] text-v3PrimaryText pad:text-32px phone:text-20px phone:leading-28px"
                    data-v-7c20b99d=""
                  >
                    {t("Hệ sinh thái Nổi bật")}
                  </div>
                  <div
                    className="mt-10px text-20px leading-[140%] text-v3TertiaryText pad:mt-12px pad:text-14px phone:mt-8px phone:text-12px"
                    data-v-7c20b99d=""
                  >
                    {t(
                      "Bảo mật là một trong những thế mạnh hàng đầu của chúng tôi."
                    )}
                  </div>
                </div>

                <div className="exchange-body " data-v-7c20b99d="">
                  {breakpoint === "mobile" ? (
                    <Swiper
                      slidesPerView={breakpoint === "mobile" ? 1 : 3}
                      loop
                      spaceBetween={10}
                      autoplay={{
                        delay: 1500,
                        disableOnInteraction: false,
                      }}
                      pagination={true}
                      modules={[Autoplay]}
                      centeredSlides
                      className="mySwiper1 w-full"
                    >
                      <SwiperSlide className="">
                        <a
                          href="#"
                          target="_blank"
                          className="exchange-body-left-top-item hover:cursor-pointer h-[200px] "
                          data-v-7c20b99d=""
                        >
                          <div
                            className="exchange-body-left-top-item-imgcon"
                            data-v-7c20b99d=""
                          >
                            <img
                              loading="lazy"
                              src="data:image/jpeg;base64,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"
                              alt="one_proof"
                              className="exchange-body-left-top-item-imgcon-img"
                              data-v-7c20b99d=""
                            />
                          </div>
                          <div data-v-7c20b99d="">
                            <div
                              className="exchange-body-left-top-item-title"
                              data-v-7c20b99d=""
                            >
                              {"Sising Swap"}
                            </div>
                            <div
                              className="exchange-body-left-top-item-des"
                              data-v-7c20b99d=""
                            >
                              {t(
                                "Sising Swap thực hiện việc trao đổi dễ dàng hỗ trợ đa chuỗi, chuỗi chéo với chi phí thấp ngay tức thì."
                              )}
                            </div>
                          </div>
                        </a>
                      </SwiperSlide>
                      <SwiperSlide className="">
                        <a
                          href="#"
                          target="_blank"
                          className="exchange-body-left-top-item hover:cursor-pointer h-[200px] "
                          data-v-7c20b99d=""
                        >
                          <div
                            className="exchange-body-left-top-item-imgcon"
                            data-v-7c20b99d=""
                          >
                            <img
                              loading="lazy"
                              src="/img/menu6.jpg"
                              alt="two_storage"
                              className="exchange-body-left-top-item-imgcon-img"
                              data-v-7c20b99d=""
                            />
                          </div>
                          <div data-v-7c20b99d="">
                            <div
                              className="exchange-body-left-top-item-title"
                              data-v-7c20b99d=""
                            >
                              BMC Fund
                            </div>
                            <div
                              className="exchange-body-left-top-item-des"
                              data-v-7c20b99d=""
                            >
                              {t(
                                "Gloombay Invest Hoạt động trong vực đầu tư, tìm kiếm các Dự án khả thi, các hạng mục có lợi nhuận cao, các công cụ định giá AI, phân tích thị trường..."
                              )}
                            </div>
                          </div>
                        </a>
                      </SwiperSlide>

                      <SwiperSlide className="">
                        <a
                          href="https://gloombay.com/"
                          target="_blank"
                          className="exchange-body-left-top-item hover:cursor-pointer h-[200px] "
                          data-v-7c20b99d=""
                        >
                          <div
                            className="exchange-body-left-top-item-imgcon"
                            data-v-7c20b99d=""
                          >
                            <img
                              loading="lazy"
                              src="/img/menu3.jpg"
                              alt="three_protection"
                              className="exchange-body-left-top-item-imgcon-img"
                              data-v-7c20b99d=""
                            />
                          </div>
                          <div data-v-7c20b99d="">
                            <div
                              className="exchange-body-left-top-item-title"
                              data-v-7c20b99d=""
                            >
                              Gloombay
                            </div>
                            <div
                              className="exchange-body-left-top-item-des"
                              data-v-7c20b99d=""
                            >
                              {t(
                                "Liên minh Công nghệ bao gồm 15 Hệ sinh thái chuyên lĩnh vực Công nghệ, Trí tuệ nhân tạo, ứng dụng Doanh nghiệp"
                              )}
                            </div>
                          </div>
                        </a>
                      </SwiperSlide>
                    </Swiper>
                  ) : (
                    <div className="grid grid-cols-3 gap-4">
                      <a
                        href="#"
                        target="_blank"
                        className="exchange-body-left-top-item hover:cursor-pointer h-[300px] "
                        data-v-7c20b99d=""
                      >
                        <div
                          className="exchange-body-left-top-item-imgcon"
                          data-v-7c20b99d=""
                        >
                          <img
                            loading="lazy"
                            src="/img/menu7.jpg"
                            alt="one_proof"
                            className="exchange-body-left-top-item-imgcon-img"
                            data-v-7c20b99d=""
                          />
                        </div>
                        <div data-v-7c20b99d="">
                          <div
                            className="exchange-body-left-top-item-title"
                            data-v-7c20b99d=""
                          >
                            {"Sising Swap"}
                          </div>
                          <div
                            className="exchange-body-left-top-item-des"
                            data-v-7c20b99d=""
                          >
                            {t(
                              "Sising Swap thực hiện việc trao đổi dễ dàng hỗ trợ đa chuỗi, chuỗi chéo với chi phí thấp ngay tức thì."
                            )}
                          </div>
                        </div>
                      </a>
                      <a
                        href="#"
                        target="_blank"
                        className="exchange-body-left-top-item hover:cursor-pointer h-[300px] "
                        data-v-7c20b99d=""
                      >
                        <div
                          className="exchange-body-left-top-item-imgcon"
                          data-v-7c20b99d=""
                        >
                          <img
                            loading="lazy"
                            src="/img/menu6.jpg"
                            alt="two_storage"
                            className="exchange-body-left-top-item-imgcon-img"
                            data-v-7c20b99d=""
                          />
                        </div>
                        <div data-v-7c20b99d="">
                          <div
                            className="exchange-body-left-top-item-title"
                            data-v-7c20b99d=""
                          >
                            BMC Fund
                          </div>
                          <div
                            className="exchange-body-left-top-item-des"
                            data-v-7c20b99d=""
                          >
                            {t(
                              "Gloombay Invest Hoạt động trong vực đầu tư, tìm kiếm các Dự án khả thi, các hạng mục có lợi nhuận cao, các công cụ định giá AI, phân tích thị trường..."
                            )}
                          </div>
                        </div>
                      </a>
                      <a
                        href="https://gloombay.com/"
                        target="_blank"
                        className="exchange-body-left-top-item hover:cursor-pointer h-[300px] "
                        data-v-7c20b99d=""
                      >
                        <div
                          className="exchange-body-left-top-item-imgcon"
                          data-v-7c20b99d=""
                        >
                          <img
                            loading="lazy"
                            src="/img/menu3.jpg"
                            alt="three_protection"
                            className="exchange-body-left-top-item-imgcon-img"
                            data-v-7c20b99d=""
                          />
                        </div>
                        <div data-v-7c20b99d="">
                          <div
                            className="exchange-body-left-top-item-title"
                            data-v-7c20b99d=""
                          >
                            Gloombay
                          </div>
                          <div
                            className="exchange-body-left-top-item-des"
                            data-v-7c20b99d=""
                          >
                            {t(
                              "Liên minh Công nghệ bao gồm 15 Hệ sinh thái chuyên lĩnh vực Công nghệ, Trí tuệ nhân tạo, ứng dụng Doanh nghiệp.."
                            )}
                          </div>
                        </div>
                      </a>
                    </div>
                  )}
                </div>
              </div>

              {/* <div className="springking-welfare-fixed-box" data-v-374ca9d2="">
                <a>
                  <img
                    src="/home_files/3a5cdf5f5ea686ee4e59b89c2904261e.png"
                    alt="suspension-banner-1"
                  />
                </a>
                <a>
                  <img
                    src="/home_files/25c9ac14660e0a55a398d7e1142b2f09.png"
                    alt="suspension-banner-2"
                  />
                </a>
              </div> */}

              <div className="py-10 px-5">
                <div className="text-center flex justify-center">
                  <h3 className="text-white text-30px">{t("Nhà đầu tư")}</h3>
                </div>
                <div
                  data-w-id="d11cb711-0780-b0e4-6247-11cd694fbc58"
                  style={{
                    opacity: 1,
                    transform:
                      "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                  }}
                  className="w-layout-grid nb-investor-grid"
                >
                  <a
                    id="w-node-_89f7f702-e68a-7893-c1db-a113b5d22ffe-6e013286"
                    href="https://www.spartangroup.io"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/6606fca2f116d6dc39cfd426_webLogo_Spartan.png"
                      loading="lazy"
                      alt="Stacks Foundation"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc59-6e013286"
                    href="https://whitestarcapital.com"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/61d268e6d64e47b25f0c1d66_webLogo_whiteStarCapital.png"
                      loading="lazy"
                      alt="white star capital"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc5b-6e013286"
                    href="https://www.cultur3.capital"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/61d268e6d64e470a030c1d60_webLogo_cultur3.png"
                      loading="lazy"
                      alt="Cultur3"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc5d-6e013286"
                    href="https://gbic.io"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/61d268e6d64e479ef40c1d5e_webLogo_GBIC.png"
                      loading="lazy"
                      alt="GBIC"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc5f-6e013286"
                    href="https://www.gbv.capital"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/61d268e6d64e477d6d0c1d5f_webLogo_GBV.png"
                      loading="lazy"
                      alt="GBV"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc61-6e013286"
                    href="https://www.riseaccel.com"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/622482793ba13eb1a6ad67ce_webLogo_SeaX.png"
                      loading="lazy"
                      alt="SeeX"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc63-6e013286"
                    href="http://www.gossamercap.com"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/61d268e6d64e4719e10c1d61_webLogo_GossamerCapital.png"
                      loading="lazy"
                      alt="Gossamer Capital"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc65-6e013286"
                    href="https://sbx.xyz"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/61d268e6d64e4770f40c1d65_webLogo_SBXCapital.png"
                      loading="lazy"
                      alt="SBX"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc67-6e013286"
                    href="https://freeholdcm.com"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/61d268e6d64e472a5f0c1d5d_webLogo_Freehold.png"
                      loading="lazy"
                      alt="Freehold"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc69-6e013286"
                    href="https://daemontechnologies.co"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/61d268e6d64e47cb820c1d62_webLogo_daemontechnologies.png"
                      loading="lazy"
                      alt="Daemon Technologies"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc6b-6e013286"
                    href="https://www.westridgemarkets.com"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/61d268e6d64e471abc0c1d63_webLogo_westridgemarket.png"
                      loading="lazy"
                      alt="Westridge Market"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc6d-6e013286"
                    href="https://www.a41ventures.com"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/61d268e6d64e4732820c1d5b_webLogo_a41ventures.png"
                      loading="lazy"
                      alt="A41 Ventures"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc6f-6e013286"
                    href="https://despread.org"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/650ef6e6becf38efdaaee8f9_investors_DeSpread.png"
                      loading="lazy"
                      sizes="(max-width: 991px) 75vw, 70vw"
                      srcSet="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/650ef6e6becf38efdaaee8f9_investors_DeSpread-p-500.png 500w, https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/650ef6e6becf38efdaaee8f9_investors_DeSpread.png 800w"
                      alt="DeSpread"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc71-6e013286"
                    href="https://www.okx.com/ventures"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/65463ed2f5444c37eb5f6b15_webLogo_OKXVentures.png"
                      loading="lazy"
                      alt="OKEx Blockdream Ventures"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc73-6e013286"
                    href="https://stacks.ac"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/61d27901cca2fa74a8bc258e_webLogo_StacksAccelarator.png"
                      loading="lazy"
                      alt="Stacks Accelarator"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc75-6e013286"
                    href="https://catchervc.chaincatcher.com"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/61d27b2fecb3a0e60159d861_webLogo_catcherVC.png"
                      loading="lazy"
                      alt="Chain Catcher VC"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc77-6e013286"
                    href="https://stacks.org"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/61d301c8335518458bd7e8d5_webLogo_stacksFoundation.png"
                      loading="lazy"
                      alt="Stacks Foundation"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-d11cb711-0780-b0e4-6247-11cd694fbc79-6e013286"
                    href="https://trustmachines.co"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/6413de351aacf020b9ee204c_trust_machines.svg"
                      loading="lazy"
                      alt="Stacks Foundation"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-_0789fd67-1dc3-4042-37ab-7f25407bb498-6e013286"
                    href="http://cmsholdings.io"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/6606fca2ea8cd423239679f9_webLogo_CMS.png"
                      loading="lazy"
                      alt="Stacks Foundation"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-e96bb2c9-cf52-0a57-09f8-d338064a87cc-6e013286"
                    href="https://www.dacm.io"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/6606fca25d3ce74213b63b35_webLogo_DACM.png"
                      loading="lazy"
                      alt="Stacks Foundation"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-_5858ff4f-2a12-ac6f-a37e-c88b215efb88-6e013286"
                    href="https://www.dwf-labs.com"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/6606fca30d3940955328814c_webLogo_DWFlabs.png"
                      loading="lazy"
                      alt="Stacks Foundation"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-feffa671-c6d5-9158-cfe5-aef1a67651d9-6e013286"
                    href="https://www.foresightventures.com"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/6606fca241692dac2c0b5cf8_webLogo_Foresightventures.png"
                      loading="lazy"
                      alt="Stacks Foundation"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-_80e38d93-918c-a44d-e38f-df1c44ecd199-6e013286"
                    href="https://www.g20.group"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/6606fca3d11311bc746d5259_webLogo_G20group.png"
                      loading="lazy"
                      alt="Stacks Foundation"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-f6712880-0b51-2699-bc87-ec8cb2406127-6e013286"
                    href="https://twitter.com/OuroborosCap8?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/6606fca3f926733859371542_webLogo_OuroborosCapital.png"
                      loading="lazy"
                      alt="Stacks Foundation"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-_3db90cb3-ef2a-a413-cf1d-f5d6cadbda6d-6e013286"
                    href="https://www.summereverest.info"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/6606fca3347f08e876c487fb_webLogo_Summerventures.png"
                      loading="lazy"
                      alt="Stacks Foundation"
                      className="nb-investorlogo"
                    />
                  </a>
                  <a
                    id="w-node-c777e914-85e4-fd3f-38ce-f83d49a8627d-6e013286"
                    href="https://trustmachines.co"
                    target="_blank"
                    className="nb-investors_link w-inline-block"
                  >
                    <img
                      src="https://assets-global.website-files.com/61d268e6d64e470e580c1c1d/6606fca355bb947a59f02bc9_webLogo_HYPERITHM.png"
                      loading="lazy"
                      alt="Stacks Foundation"
                      className="nb-investorlogo"
                    />
                  </a>
                </div>
              </div>
              <div className="my-[40px] flex-col  flex justify-center items-center">
                <div className="text-[15px] text-[#fff]">
                  {t("Liên kết mạng xã hội")}
                </div>
                <div className="flex items-center gap-2 mt-[21px]">
                  <a target="_blank" href="#">
                    <div className="facebook" id="facebook">
                      <svg
                        className="w-[32px] h-[32px] md:w-[48px] md:h-[48px]"
                        viewBox="0 0 46 45"
                        fill="#323232"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="45.0402" height={45} rx={4} fill="" />
                        <g clipPath="url(#clip0_2297_2968)">
                          <path
                            d="M24.5094 32.4052V23.6116H27.5441L27.9985 20.1846H24.5094V17.9966C24.5094 17.0044 24.7927 16.3282 26.2557 16.3282L28.1215 16.3274V13.2623C27.7986 13.2207 26.6911 13.1274 25.4027 13.1274C22.7126 13.1274 20.8709 14.7244 20.8709 17.6574V20.1847H17.8284V23.6117H20.8708V32.4053L24.5094 32.4052Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_2297_2968">
                            <rect
                              width="10.2931"
                              height="19.2823"
                              fill="white"
                              transform="translate(17.8284 13.125)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </a>
                  <a target="_blank" href="#">
                    <div className="whtsapp " id="whtsapp">
                      <svg
                        className="w-[32px] h-[32px] md:w-[48px] md:h-[48px]"
                        viewBox="0 0 46 45"
                        fill="#323232"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.0400391"
                          width="45.0402"
                          height={45}
                          rx={4}
                          fill=""
                        />
                        <path
                          d="M18.3128 21.091V23.9273H23.0047C22.8156 25.1446 21.5865 27.4964 18.3128 27.4964C15.4883 27.4964 13.1837 25.1564 13.1837 22.2728C13.1837 19.3891 15.4883 17.0491 18.3128 17.0491C19.9201 17.0491 20.9956 17.7346 21.6101 18.3255L23.8556 16.1627C22.4137 14.8155 20.5465 14 18.3128 14C13.7392 14 10.04 17.6991 10.04 22.2728C10.04 26.8464 13.7392 30.5456 18.3128 30.5456C23.0874 30.5456 26.2547 27.1892 26.2547 22.4619C26.2547 21.9182 26.1956 21.5046 26.1247 21.091H18.3128Z"
                          fill="white"
                        />
                        <path
                          d="M36.0397 21.0907H33.676V18.7271H31.3124V21.0907H28.9487V23.4544H31.3124V25.818H33.676V23.4544H36.0397"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </a>
                  <a target="_blank" href="#">
                    <div className="twitter " id="twitter">
                      <svg
                        className="w-[32px] h-[32px] md:w-[48px] md:h-[48px]"
                        viewBox="0 0 46 45"
                        fill="#323232"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.0402832"
                          width="45.0402"
                          height={45}
                          rx={4}
                          fill=""
                        />
                        <path
                          d="M32.4132 16.0164C31.6927 16.325 30.8693 16.5306 30.0458 16.6335C30.8693 16.1193 31.5898 15.2966 31.8986 14.371C31.0751 14.8852 30.2517 15.1937 29.2224 15.3994C28.5019 14.5767 27.3696 14.0625 26.2374 14.0625C23.9729 14.0625 22.1201 15.9136 22.1201 18.1761C22.1201 18.4846 22.1201 18.7931 22.2231 19.1016C18.8263 18.8959 15.7384 17.2505 13.6798 14.7824C13.371 15.3994 13.1651 16.1193 13.1651 16.8392C13.1651 18.2789 13.8857 19.513 15.0179 20.2328C14.2974 20.2328 13.6798 20.0272 13.1651 19.7186C13.1651 21.6726 14.6062 23.4208 16.4589 23.7294C16.1501 23.8322 15.7384 23.8322 15.3267 23.8322C15.0179 23.8322 14.812 23.8322 14.5032 23.7294C15.0179 25.3748 16.5619 26.6089 18.4146 26.6089C16.9736 27.7401 15.2238 28.3571 13.2681 28.3571C12.9593 28.3571 12.6505 28.3571 12.2388 28.2543C14.0915 29.3855 16.2531 30.1054 18.6205 30.1054C26.2374 30.1054 30.3546 23.8322 30.3546 18.3817V17.8675C31.178 17.559 31.8986 16.8391 32.4132 16.0164Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </a>
                  <a target="_blank" href="#">
                    <div className="pinterest " id="pinterest">
                      <svg
                        className="w-[32px] h-[32px] md:w-[48px] md:h-[48px]"
                        viewBox="0 0 46 45"
                        fill="#323232"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.161133"
                          width="45.0402"
                          height={45}
                          rx={4}
                          fill=""
                        />
                        <path
                          d="M28.5611 15.0943C27.247 13.7814 25.3582 13.125 23.305 13.125C20.1842 13.125 18.2953 14.4378 17.2277 15.5045C15.9137 16.8174 15.1746 18.5405 15.1746 20.3456C15.1746 22.561 16.0779 24.2021 17.6383 24.8585C17.7205 24.9406 17.8847 24.9406 17.9668 24.9406C18.2953 24.9406 18.5417 24.6944 18.6239 24.3662C18.706 24.2021 18.7881 23.7098 18.8702 23.4636C18.9523 23.0534 18.8702 22.8892 18.6239 22.561C18.2132 22.0687 17.9668 21.4123 17.9668 20.5918C17.9668 18.2123 19.7736 15.6686 23.0586 15.6686C25.6867 15.6686 27.3292 17.1456 27.3292 19.5251C27.3292 21.002 27.0007 22.3969 26.4258 23.4636C26.0152 24.2021 25.276 25.0226 24.2084 25.0226C23.7156 25.0226 23.305 24.8585 23.0586 24.4482C22.8123 24.12 22.7301 23.7098 22.8122 23.2995C22.8944 22.8072 23.0586 22.3149 23.2229 21.8226C23.4693 20.92 23.7978 20.0174 23.7978 19.361C23.7978 18.2123 23.0586 17.3917 21.991 17.3917C20.5949 17.3917 19.5272 18.7866 19.5272 20.5097C19.5272 21.4123 19.7736 21.9867 19.8557 22.2328C19.6915 22.9713 18.6238 27.3201 18.4596 28.0585C18.3775 28.5509 17.6383 32.3253 18.7881 32.5714C20.02 32.8996 21.1697 29.2073 21.2519 28.797C21.334 28.4688 21.6625 27.156 21.8268 26.4175C22.4016 26.9919 23.3871 27.4021 24.3727 27.4021C26.1794 27.4021 27.7398 26.5816 28.8896 25.1047C29.9572 23.7098 30.6142 21.7405 30.6142 19.5251C30.5321 18.0482 29.8751 16.3251 28.5611 15.0943Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </a>
                  <a target="_blank" href="#">
                    <div className="whtsapp " id="whtsapp">
                      <svg
                        className="w-[32px] h-[32px] md:w-[48px] md:h-[48px]"
                        viewBox="0 0 46 45"
                        fill="#323232"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.0400391"
                          width="45.0402"
                          height={45}
                          rx={4}
                          fill=""
                        />
                        <path
                          d="M28.9291 14.0528C30.2064 14.1845 31.8674 14.0528 32.7619 15.0988C33.7842 16.144 33.913 17.841 33.913 19.1476C34.04 20.7148 34.04 22.9367 34.04 24.3714C33.913 25.8096 34.04 27.5058 33.3996 28.8142C32.7628 30.2489 31.6116 30.7737 30.2064 30.9026C28.6715 31.0325 19.2171 31.0325 16.1518 30.9026C14.7458 30.7728 13.0848 30.7728 12.0624 29.5969C11.1679 28.5509 11.1679 26.9846 11.04 25.6789C11.04 24.1108 11.04 21.8898 11.04 20.3235C11.04 18.8861 11.04 17.1891 11.6787 15.8825C12.3182 14.5767 13.5955 14.3152 15.0007 14.1854C16.5338 14.0537 25.8603 13.9239 28.9282 14.0537L28.9291 14.0528ZM19.9846 18.4939V26.3299L27.0123 22.4119L19.9846 18.4939Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </a>
                  <a target="_blank" href="#">
                    <div className="instagram " id="instagram">
                      <svg
                        className="w-[32px] h-[32px] md:w-[48px] md:h-[48px]"
                        viewBox="0 0 46 45"
                        fill="#323232"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.0805664"
                          width="45.0402"
                          height={45}
                          rx={4}
                          fill=""
                        />
                        <path
                          d="M28.8545 14.0625H16.5944C15.2101 14.0625 14.1555 15.1162 14.1555 16.4992V28.7483C14.1555 30.1313 15.2101 31.185 16.5944 31.185H28.8545C30.2387 31.185 31.2933 30.1313 31.2933 28.7483V16.4992C31.2933 15.1162 30.2387 14.0625 28.8545 14.0625ZM22.7244 27.7605C25.5587 27.7605 27.8657 25.5214 27.8657 22.8213C27.8657 22.3603 27.7998 21.8335 27.668 21.4383H29.1181V28.419C29.1181 28.7483 28.8545 29.0776 28.459 29.0776H16.9898C16.6603 29.0776 16.3307 28.8142 16.3307 28.419V21.3725H17.8467C17.7149 21.8335 17.649 22.2945 17.649 22.7554C17.5831 25.5214 19.8901 27.7605 22.7244 27.7605ZM22.7244 25.7848C20.8788 25.7848 19.4287 24.336 19.4287 22.5579C19.4287 20.7798 20.8788 19.331 22.7244 19.331C24.57 19.331 26.0201 20.7798 26.0201 22.5579C26.0201 24.4018 24.57 25.7848 22.7244 25.7848ZM29.0522 18.7383C29.0522 19.1334 28.7226 19.4627 28.3271 19.4627H26.4815C26.086 19.4627 25.7565 19.1334 25.7565 18.7383V16.9601C25.7565 16.565 26.086 16.2357 26.4815 16.2357H28.3271C28.7226 16.2357 29.0522 16.565 29.0522 16.9601V18.7383Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
              <div
                className=" my-[40px] flex justify-center text-12px text-v3DisabledText"
                data-v-374ca9d2=""
              >
                © 2024 Sising
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
